module.exports = __webpack_public_path__ + "img/func3.4657e00e.png";